<template>
	<div
		class="loader"
		:class="{
			'loader--backdrop': backdrop,
			'loader--sticky': sticky,
		}"
		v-if="show"
	>
		<div class="loader__spinner">
			<div class="loader__ring"></div>
			<div class="loader__ring"></div>
			<div class="loader__ring"></div>
			<div class="loader__ring"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		show: Boolean,
		backdrop: Boolean,
		sticky: Boolean,
	}
}
</script>

<style>

</style>